import "./App.css";
import { PageRouting } from "./PageRouting";
import "antd/dist/reset.css";
import { ConfigProvider } from "antd";
import { VoiceCommandProvider } from "./Components/Pages/VoiceCommand/VoiceContext";
import { useSelector } from "react-redux";

function App() {
  const loader = useSelector((state) => state.common.loader);

  return (
    <VoiceCommandProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#1D64C8",
          },
          components: {
            Segmented: {
              itemSelectedBg: "#1D64C8",
            },
          },
        }}
      >
        {loader && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <PageRouting />
      </ConfigProvider>
    </VoiceCommandProvider>
  );
}

export default App;
